var _G, _Defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";
function SvgFaq(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 21",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#faq_svg__clip0_11155_4701)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M20.5 14.07a6.48 6.48 0 00-4.734-6.23c-.174-4.058-3.53-7.305-7.63-7.305C3.927.535.5 3.96.5 8.17c0 1.373.365 2.709 1.059 3.882L.529 15.78l3.726-1.03a7.608 7.608 0 003.55 1.05 6.48 6.48 0 006.23 4.735 6.44 6.44 0 003.29-.9l3.147.871-.87-3.147a6.442 6.442 0 00.898-3.29zm-16.06-.588l-2.231.617.617-2.23-.14-.22A6.443 6.443 0 011.671 8.17c0-3.564 2.9-6.464 6.465-6.464 3.564 0 6.465 2.9 6.465 6.464 0 3.565-2.9 6.465-6.465 6.465-1.237 0-2.44-.35-3.477-1.013l-.22-.14zm14.351 5.344l-1.655-.458-.221.144a5.273 5.273 0 01-2.88.85 5.306 5.306 0 01-5.018-3.605 7.651 7.651 0 006.706-6.705 5.307 5.307 0 013.605 5.018 5.273 5.273 0 01-.851 2.88l-.144.22.458 1.656z"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M7.55 11.12h1.173v1.173H7.55V11.12zM9.309 6.394c0 .333-.136.64-.382.865L7.551 8.52v1.43h1.172v-.914l.995-.911a2.35 2.35 0 00.762-1.73A2.346 2.346 0 008.137 4.05a2.346 2.346 0 00-2.344 2.344h1.172a1.173 1.173 0 012.344 0z"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "faq_svg__clip0_11155_4701"
  }, /*#__PURE__*/React.createElement(Path, {
    transform: "translate(.5 .535)",
    d: "M0 0h20v20H0z"
  })))));
}
export default SvgFaq;